import { getMultiViewConstraints } from 'Pods/ThreeDStudio/Shared/Utils/getMultiViewConstraints'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

const mapParamToStateKey = {
  input_image: 'inputImage',
}

// Multi-view needs the views the schema marks required (front and back) plus enough views
// overall to reach the provider's minimum. Views the provider does not accept are not
// counted, mirroring the payload.
const isMultiViewInputFulfilled = (modelSettings, inputImageSchema) => {
  const { viewTypes, minItems, requiredViews } = getMultiViewConstraints(inputImageSchema)
  const isFilled = viewType => modelSettings.inputViewImages?.[viewType]?.id != null
  const filledViews = viewTypes.filter(isFilled)

  return filledViews.length >= minItems && requiredViews.every(isFilled)
}

export default function useAreRequiredParamsFulfilled(isEnhancementMode) {
  const areRequiredParamsFulfilled = useThreeDStudioStore(state => {
    const { modelSettings, viewer, schema } = state
    const modelSchema = isEnhancementMode ? schema?.enhancedModelSchema : schema?.generationModelSchema
    const requiredParams = modelSchema?.input_schema?.required || []

    if (requiredParams.length === 0) {
      return true
    }

    return requiredParams.every(param => {
      if (param === 'input_3d') {
        const value = viewer?.inputThreeD
        return value !== undefined && value !== null && value !== ''
      }

      if (param === 'input_image' && !isEnhancementMode && modelSettings?.isMultiView) {
        return isMultiViewInputFulfilled(modelSettings, modelSchema.input_schema.properties?.input_image)
      }

      const key = mapParamToStateKey[param] || param
      const value = modelSettings?.[key] ?? state[key]
      if (value === undefined || value === null || value === '' || Array.isArray(value) && value.length === 0) {
        return false
      }

      const inputSchemaField = modelSchema.input_schema.properties[param]
      if (
        inputSchemaField.type === 'string' &&
        (value.length < inputSchemaField.minLength || value.length > inputSchemaField.maxLength)
      ) {
        return false
      }

      return true
    })
  })

  return areRequiredParamsFulfilled
}
